'use client';

import { ListboxSeparator } from "../../utils/listbox-separator/ListboxSeparator.mjs";
/**
 * A visual separator between items or groups.
 * Renders a `<div>` element.
 *
 * Documentation: [Base UI Autocomplete](https://base-ui.com/react/components/autocomplete)
 */
export const AutocompleteSeparator = ListboxSeparator;